import Control from "../1. Core/Control";
import DataTable from "../1. Core/Controls/DataTable/DataTable";
import {ServerAPI} from "../1. Core/ServerAPI";
import Label from "../1. Core/Controls/Label/Label";
import Button from "../1. Core/Controls/Button/Button";
import TextField from "../1. Core/Controls/TextField/TextField";
import NP, {EventArgs} from "../1. Core/NP";
import Menu from "../1. Core/Controls/Menu/Menu";



export default class WebhookPanel extends Control {
	private _Offset: number;
	private _Count: number;
	private _FilterText: string;

	private _list: DataTable;
	private lbl: Label;
	private addBtn: Button;
	private urlInput: TextField;


	constructor(settings?: object)
	{
		super(settings);
		this._render();
	}

	_render()
	{
		this.np_render();

		this._root.style.marginLeft = '24px'

		this._Offset = 0;
		this._Count = 100;
		this._FilterText = "";


		this.lbl = new Label({
			Content: 'Spectation Sport webhooks',
			ParentNode: this._root
		})


		let apiKeyParam = NP.getQueryParam('apikey')

		this._list = new DataTable({
			ParentNode: this._root,
			ShowPaginator: false,
			Width: 400,
			ShowSettingsButton: true,
			Columns: [{
				Content: 'id',
				PropertyContent: 'id',
				Width: '50px'
			}, {
				Content: 'Url',
				PropertyContent: 'url',
				Width: '350px'
			}],
			EvItemContextMenu: (sender: Control, args: EventArgs) =>
			{
				const webhook = args.Item as Webhook;
				let menu = new Menu({
					Items: [{RK: 'Delete'}],
					EvItemSelected: async () => {
						await ServerAPI.delet<Webhook[]>(`/webhook/${webhook.id}?apikey=${apiKeyParam}`)

						this.refresh();
					}
				})
				menu.showContextMenu(args.Event);
			}
		});


		let addCnt = NP.createNode(this._root)

		this.urlInput = new TextField({
			ParentNode: addCnt,
			Width: 300,
			FloatingLabel: 'Url'
		})

		this.addBtn = new Button({
			ParentNode: addCnt,
			RK: 'Add',
			EvClick: async () => {
				let url = this.urlInput.getValue();
				if (url && url.startsWith("https://"))
				{
					await ServerAPI.post<Webhook[]>(`/webhook?apikey=${apiKeyParam}`, {
						url: url
					})

					this.urlInput.setValue('')
					this.refresh();
				}
			}
		})

		this.addBtn.getRoot().style.marginTop = '79px'

		this.refresh();
	}


	setHeight(value: number)
	{
		super.setHeight(value);
		if (this._list)
			this._list.setHeight(this._Height - 64);
	}

	setWidth(value: number)
	{
		super.setWidth(value);
		if (this._list)
			this._list.setWidth(value);
	}


	async refresh()
	{
		let apiKeyParam = NP.getQueryParam('apikey')
		let items = await ServerAPI.get<Webhook[]>(`/webhook?apikey=${apiKeyParam}`)

		if (items)
			this._list.setRows(items);
	}
}


interface Webhook {
	id: number,
	tournamentId: number,
	url: string
}
